// Supported locales as lowercase BCP 47 language tags (e.g. 'en-us').
// https://www.rfc-editor.org/info/bcp47
export enum Locale {
  DaDk = 'da-dk',
  DeAt = 'de-at',
  DeCh = 'de-ch',
  DeDe = 'de-de',
  EnCa = 'en-ca',
  EnGb = 'en-gb',
  EnIe = 'en-ie',
  EnPseudo = 'en-pseudo',
  EnUs = 'en-us',
  EsEs = 'es-es',
  FiFi = 'fi-fi',
  FrCa = 'fr-ca',
  FrFr = 'fr-fr',
  ItIt = 'it-it',
  NbNo = 'nb-no',
  NlBe = 'nl-be',
  NlNl = 'nl-nl',
  PlPl = 'pl-pl',
  SvSe = 'sv-se',
}

export const LOCALES: Locale[] = [
  Locale.DaDk,
  Locale.DeAt,
  Locale.DeCh,
  Locale.DeDe,
  Locale.EnCa,
  Locale.EnGb,
  Locale.EnIe,
  Locale.EnPseudo,
  Locale.EnUs,
  Locale.EsEs,
  Locale.FiFi,
  Locale.FrCa,
  Locale.FrFr,
  Locale.ItIt,
  Locale.NbNo,
  Locale.NlBe,
  Locale.NlNl,
  Locale.PlPl,
  Locale.SvSe,
];

// Language subtags of the supported locales (the "en" in "en-us"), as lowercase
// BCP 47 language codes. Kept in sync with LOCALES by language.test.ts.
// https://www.rfc-editor.org/info/bcp47
export enum Language {
  Da = 'da',
  De = 'de',
  En = 'en',
  Es = 'es',
  Fi = 'fi',
  Fr = 'fr',
  It = 'it',
  Nb = 'nb',
  Nl = 'nl',
  Pl = 'pl',
  Sv = 'sv',
}

export const LANGUAGES: Language[] = [
  Language.Da,
  Language.De,
  Language.En,
  Language.Es,
  Language.Fi,
  Language.Fr,
  Language.It,
  Language.Nb,
  Language.Nl,
  Language.Pl,
  Language.Sv,
];

export enum Workspace {
  App = 'app',
  Components = 'components',
  Constants = 'constants',
  Kibble = 'kibble',
  Mobile = 'mobile',
  Pages = 'pages',
  ReactApp = 'react-app',
  ReactLib = 'react-lib',
  ReactNativeApp = 'reactNativeApp',
  Rsdk = 'rsdk',
  Shared = 'shared',
  SsrRover = 'ssr-rover',
  Types = 'types',
  Utilities = 'utilities',
}

// All Workspaces that include i18n messages
export const WORKSPACES: Workspace[] = [
  Workspace.App,
  Workspace.Components,
  Workspace.Constants,
  Workspace.Kibble,
  Workspace.Mobile,
  Workspace.Pages,
  Workspace.ReactApp,
  Workspace.ReactLib,
  Workspace.ReactNativeApp,
  Workspace.Rsdk,
  Workspace.Shared,
  Workspace.SsrRover,
  Workspace.Types,
  Workspace.Utilities,
];
